







export default
  name: '404'

  data: () ->
    url: 'https://export.fcsl-group.com'

  created: () ->
    @url = @url + @$route.path

